import React, { FC } from "react";
import { QuestionConfigBasicsDto } from "@green0meter/api-client";
import { Control, Controller, FieldValues } from "react-hook-form";

import { InputTypeEnumKeys } from "@type/Input";
import { Checkbox, TableCell, TableRow } from "@components/base";
import { ChipId, InputType } from "@components/common";

interface Row {
  question: QuestionConfigBasicsDto;
  control: Control<FieldValues, string>;
}

const Row: FC<Row> = ({ question, control }) => {
  return (
    <TableRow key={`question-${question.id}`} evenOdd>
      <TableCell>
        <Controller
          control={control}
          name={`questions.${question.id}`}
          render={({ field }) => <Checkbox {...field} />}
        />
      </TableCell>
      <TableCell>
        <ChipId id={question.id} />
      </TableCell>
      <TableCell>{question.name}</TableCell>
      <TableCell>
        <InputType type={question.componentType as InputTypeEnumKeys} />
      </TableCell>
    </TableRow>
  );
};

export default Row;
